import { defineMessages } from 'react-intl';

const prefix = 'app.containers.TranslationSettings';

export const messages = defineMessages({
  customTerminologyTab: {
    id: `${prefix}.customTerminologyTab`,
    defaultMessage: 'Custom Terminology',
  },
  header: {
    id: `${prefix}.header`,
    defaultMessage: 'Translation Settings',
  },
  mergeKeyTab: {
    id: `${prefix}.mergeKeyTab`,
    defaultMessage: 'Merge Keys',
  },
  subtitle: {
    id: `${prefix}.subtitle`,
    defaultMessage:
      'Manage how applicant facing content is translated. Upload custom terminology to fine-tune wording, or choose which merge key values should be translated by AWS.',
  },
});
